module.exports = __webpack_public_path__ + "img/crowdFunding.99bf9e9a.png";